var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Modal',{attrs:{"title":_vm.title,"width":"430"},on:{"on-ok":_vm.callbackFunc},model:{value:(_vm.modal),callback:function ($$v) {_vm.modal=$$v},expression:"modal"}},[_c('p',[_vm._v("确认删除吗？删除后不可恢复。")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }